module.exports = __webpack_public_path__ + "about-us-b998e096/people-740e0233d92b7a9a7bf2f175bd069050.svg";